import type { ReactNode } from "react";

type Props = {
    children: ReactNode;
    footer?: ReactNode;
    className?: string;
    footerAriaLive?: "polite" | "off" | "assertive";
};

export default function ModelEvaluationFilterBar(props: Props) {
    return (
        <div className={`card p-0 ${props.className ?? "mb-3"}`}>
            <div className="card-content px-3 py-3 border-bottom bg-light">
                {props.children}
                {props.footer != null && (
                    <p
                        className="text-muted small mb-0 mt-2"
                        {...(props.footerAriaLive != null ? { "aria-live": props.footerAriaLive } : {})}
                    >
                        {props.footer}
                    </p>
                )}
            </div>
        </div>
    );
}
